var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 8,
  fill: "#FF4A31"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 4,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#fff"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 4,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#fff"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcng9IjgiIGZpbGw9IiNGRjRBMzEiLz4KICAgIDxyZWN0IHg9IjUiIHk9IjQiIHdpZHRoPSIyIiBoZWlnaHQ9IjgiIHJ4PSIxIiBmaWxsPSJ3aGl0ZSIvPgogICAgPHJlY3QgeD0iOSIgeT0iNCIgd2lkdGg9IjIiIGhlaWdodD0iOCIgcng9IjEiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgStop as ReactComponent };